"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseUserOnboardingStep = void 0;
const UserOnboardingStepStatus_1 = require("./UserOnboardingStepStatus");
const infrastructure_1 = require("../../infrastructure");
class BaseUserOnboardingStep {
    constructor(data) {
        this.isOptional = false;
        this.data = data;
    }
    get status() {
        if (!this.data)
            return UserOnboardingStepStatus_1.UserOnboardingStepStatus.NOT_STARTED;
        else if (this.isComplete())
            return UserOnboardingStepStatus_1.UserOnboardingStepStatus.COMPLETE;
        else
            return UserOnboardingStepStatus_1.UserOnboardingStepStatus.STARTED;
    }
    isComplete() {
        return this.data?.isComplete() === true;
    }
}
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], BaseUserOnboardingStep.prototype, "status", null);
exports.BaseUserOnboardingStep = BaseUserOnboardingStep;
//# sourceMappingURL=BaseUserOnboardingStep.js.map